require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-school-alternative-college.json") })
        }
      }, "path---blog-code-school-alternative-college");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-school-alternative-college!./.cache/json/blog-code-school-alternative-college.json
// module id = 773
// module chunks = 231608221292675